export const translations = {
  de: {
    nav: {
      leistungen: "Leistungen",
      equipment: "Equipment",
      about: "Über uns",
      kontakt: "Kontakt",
      cta: "Anfrage senden",
    },
    hero: {
      badge: "Eventservice · Consulting · Support",
      titleLine1: "Ihr Event.",
      titleAccent: "Komplett",
      titleLine2: " umgesetzt.",
      subtitle:
        "Von der Planung über Essen & Getränke bis zum Equipment – inklusive Personal. Dazu Beratung und Schulungen für die Gastronomie, damit Ihr Team souveräner auftritt und mehr verkauft.",
      ctaPrimary: "Jetzt Anfrage stellen",
      ctaSecondary: "Unsere Leistungen",
    },
    ribbon: [
      "CONSULTING",
      "EVENT-PLANUNG",
      "SCHULUNGEN",
      "EQUIPMENT-VERMIETUNG",
      "COCKTAILMASCHINEN-BAU",
      "COCKTAILKURSE",
      "PERSONAL",
      "CATERING",
    ],
    leistungen: {
      overline: "Was wir tun",
      title: "Unsere Dienstleistungen im Überblick",
      subtitle:
        "Jede Leistung einzeln – oder alles aus einer Hand. Wählen Sie genau das, was Ihr Betrieb oder Event braucht.",
      ctaPrefix: "Anfrage zu",
      services: {
        consulting: {
          tag: "Consulting",
          title: "Consulting & Beratung",
          text: "Wir beraten Unternehmen im Gastro-Bereich – für effizientere Abläufe, einen besseren Umgang mit Ihren Gästen und spürbar mehr Umsatz.",
          points: ["Prozesse & Abläufe optimieren", "Kundenumgang verbessern", "Mehr verkaufen"],
        },
        schulungen: {
          tag: "Schulungen",
          title: "Schulungen für Servicepersonal",
          text: "Wir schulen Ihr Team im Umgang mit Gästen und im aktiven Verkauf – für mehr Souveränität, höhere Zusatzverkäufe und zufriedene Gäste.",
          points: ["Servicequalität steigern", "Aktiver Verkauf & Upselling", "Sicheres Auftreten"],
        },
        events: {
          tag: "Eventservice",
          title: "Veranstaltungen komplett umgesetzt",
          text: "Von der Planung über Essen und Getränke bis zum Ablauf – wir organisieren Ihr Event von A bis Z, mit erfahrenem Personal.",
          points: ["Komplette Planung", "Essen & Getränke", "Personal vor Ort"],
        },
        cocktail: {
          tag: "Eigenbau",
          title: "Cocktailmaschinen-Bau",
          text: "Wir bauen eigene Cocktailmaschinen – für schnellen, gleichbleibend guten Ausschank auf jeder Veranstaltung.",
          points: ["Individuelle Anfertigung", "Schneller Ausschank", "Gleichbleibende Qualität"],
        },
        cocktailkurse: {
          tag: "Cocktailkurse",
          title: "Cocktailkurse & Mixology-Workshops",
          text: "Erleben Sie den Spaß hinter der Bar: In unseren Cocktailkursen lernen Sie und Ihr Team, Klassiker und eigene Kreationen wie Profis zu mixen – ideal für Teamevents, Feiern oder als besonderes Erlebnis.",
          points: ["Für Teams & private Feiern", "Klassiker & eigene Kreationen", "Mit Profi-Anleitung & Equipment"],
        },
        verleih: {
          tag: "Verleih",
          title: "Verleih von Equipment",
          text: "Theken, Stehtische, Bierwagen, Ausschankwagen, Cocktailmaschinen, Spül- und Kühlwagen – alles, was Ihr Event braucht, geliefert und einsatzbereit.",
          points: ["Komplette Event-Ausstattung", "Lieferung & Aufbau", "Flexibel kombinierbar"],
          ctaLabel: "Equipment ansehen",
        },
      },
    },
    equipment: {
      overline: "Vermietung",
      title: "Equipment für jedes Event",
      subtitle: "Alles, was Ihre Veranstaltung braucht – geliefert, aufgebaut und einsatzbereit.",
      items: [
        { name: "Theken", desc: "Mobile Bar- und Ausschanktheken in verschiedenen Größen." },
        { name: "Stehtische", desc: "Elegante Stehtische inkl. Husse für jedes Event." },
        { name: "Bierwagen", desc: "Zapfanlagen & Bierwagen, einsatzbereit geliefert." },
        { name: "Ausschankwagen", desc: "Kompakte Ausschankwagen für Getränke aller Art." },
        { name: "Cocktailmaschinen", desc: "Von uns gebaute Cocktailmaschinen für schnellen Service." },
        { name: "Spülwagen", desc: "Mobile Spültechnik für hygienischen Ablauf vor Ort." },
        { name: "Kühlwagen", desc: "Kühlanhänger halten Speisen & Getränke perfekt gekühlt." },
      ],
    },
    about: {
      overline: "Über uns",
      title: "JA! Consulting & Support",
      text: "Wir sind Ihr Partner für Eventservice, Consulting und Support in der Gastronomie. Wir setzen Veranstaltungen komplett um, vermieten das passende Equipment und bauen eigene Cocktailmaschinen – und wir machen Ihr Team fit für Gäste und Verkauf.",
      points: [
        "Geschultes Servicepersonal",
        "Erfahrung in Gastronomie & Eventmanagement",
        "Alles aus einer Hand – von Planung bis Abbau",
        "Zuverlässig, flexibel und persönlich",
      ],
      stats: [
        { value: "100%", label: "Umsetzung aus einer Hand" },
        { value: "7+", label: "Equipment-Kategorien" },
        { value: "1:1", label: "Persönliche Betreuung" },
      ],
      badge: "Personal",
    },
    contact: {
      overline: "Kontakt",
      title: "Lassen Sie uns Ihr Event planen",
      text: "Schreiben Sie uns Ihre Anfrage – ob Veranstaltung, Equipment, Schulung oder Beratung. Wir melden uns schnellstmöglich bei Ihnen.",
      phoneLabel: "Telefonische Beratung auf Anfrage",
      locationLabel: "Deutschlandweit im Einsatz",
      form: {
        name: "Name *",
        email: "E-Mail *",
        phone: "Telefon",
        subject: "Betreff",
        message: "Ihre Nachricht *",
        submit: "Anfrage senden",
        sending: "Wird gesendet…",
        required: "* Pflichtfelder",
      },
      toastSuccess: "Vielen Dank! Ihre Anfrage wurde gesendet.",
      toastError: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      toastValidation: "Bitte Name, E-Mail und Nachricht ausfüllen.",
    },
    footer: {
      tagline:
        "Eventservice, Consulting & Support für die Gastronomie – komplette Umsetzung, Equipment-Vermietung und Schulungen.",
      impressum: "Impressum",
      rights: "Alle Rechte vorbehalten.",
    },
    impressum: {
      title: "Impressum",
      backHome: "Zurück zur Startseite",
      h_anbieter: "Angaben gemäß § 5 DDG",
      legalForm: "Rechtsform: Einzelunternehmen",
      h_vertreten: "Vertreten durch",
      h_kontakt: "Kontakt",
      phone: "Telefon",
      email: "E-Mail",
      h_verantwortlich: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
      h_streit: "Verbraucherstreitbeilegung / Universalschlichtungsstelle",
      streit:
        "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
      h_haftungInhalte: "Haftung für Inhalte",
      haftungInhalte:
        "Als Diensteanbieter sind wir gemäß § 7 Abs.1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.",
      h_haftungLinks: "Haftung für Links",
      haftungLinks:
        "Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.",
      h_urheber: "Urheberrecht",
      urheber:
        "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet.",
    },
  },

  en: {
    nav: {
      leistungen: "Services",
      equipment: "Equipment",
      about: "About us",
      kontakt: "Contact",
      cta: "Send request",
    },
    hero: {
      badge: "Event service · Consulting · Support",
      titleLine1: "Your event.",
      titleAccent: "Fully",
      titleLine2: " delivered.",
      subtitle:
        "From planning to food & drinks to equipment – staff included. Plus consulting and training for the hospitality sector, so your team performs with confidence and sells more.",
      ctaPrimary: "Request now",
      ctaSecondary: "Our services",
    },
    ribbon: [
      "CONSULTING",
      "EVENT PLANNING",
      "TRAINING",
      "EQUIPMENT RENTAL",
      "COCKTAIL MACHINE BUILDING",
      "COCKTAIL COURSES",
      "STAFF",
      "CATERING",
    ],
    leistungen: {
      overline: "What we do",
      title: "Our services at a glance",
      subtitle:
        "Each service on its own – or everything from a single source. Choose exactly what your business or event needs.",
      ctaPrefix: "Request",
      services: {
        consulting: {
          tag: "Consulting",
          title: "Consulting & Advisory",
          text: "We advise hospitality businesses – for more efficient operations, better guest interactions and a noticeable increase in revenue.",
          points: ["Optimise processes & workflows", "Improve guest handling", "Sell more"],
        },
        schulungen: {
          tag: "Training",
          title: "Training for service staff",
          text: "We train your team in guest interaction and active selling – for more confidence, higher add-on sales and happy guests.",
          points: ["Boost service quality", "Active selling & upselling", "Confident presence"],
        },
        events: {
          tag: "Event service",
          title: "Events delivered end to end",
          text: "From planning to food and drinks to execution – we organise your event from A to Z, with experienced staff.",
          points: ["Complete planning", "Food & drinks", "Staff on site"],
        },
        cocktail: {
          tag: "In-house build",
          title: "Cocktail machine building",
          text: "We build our own cocktail machines – for fast, consistently great serving at any event.",
          points: ["Custom-built", "Fast serving", "Consistent quality"],
        },
        cocktailkurse: {
          tag: "Cocktail courses",
          title: "Cocktail courses & mixology workshops",
          text: "Experience the fun behind the bar: in our cocktail courses you and your team learn to mix classics and your own creations like a pro – ideal for team events, celebrations or as a special experience.",
          points: ["For teams & private parties", "Classics & own creations", "With pro guidance & equipment"],
        },
        verleih: {
          tag: "Rental",
          title: "Equipment rental",
          text: "Bars, standing tables, beer wagons, serving trailers, cocktail machines, dishwashing and refrigeration trailers – everything your event needs, delivered and ready to use.",
          points: ["Complete event setup", "Delivery & setup", "Flexibly combinable"],
          ctaLabel: "View equipment",
        },
      },
    },
    equipment: {
      overline: "Rental",
      title: "Equipment for every event",
      subtitle: "Everything your event needs – delivered, set up and ready to use.",
      items: [
        { name: "Bars / Counters", desc: "Mobile bar and serving counters in various sizes." },
        { name: "Standing tables", desc: "Elegant standing tables incl. covers for any event." },
        { name: "Beer wagons", desc: "Beer taps & wagons, delivered ready to use." },
        { name: "Serving trailers", desc: "Compact serving trailers for drinks of all kinds." },
        { name: "Cocktail machines", desc: "Cocktail machines built by us for fast service." },
        { name: "Dishwashing trailers", desc: "Mobile dishwashing tech for hygienic operations on site." },
        { name: "Refrigeration trailers", desc: "Refrigerated trailers keep food & drinks perfectly cool." },
      ],
    },
    about: {
      overline: "About us",
      title: "JA! Consulting & Support",
      text: "We are your partner for event service, consulting and support in the hospitality sector. We deliver events end to end, rent out the right equipment and build our own cocktail machines – and we get your team ready for guests and sales.",
      points: [
        "Trained service staff",
        "Experience in hospitality & event management",
        "Everything from one source – from planning to teardown",
        "Reliable, flexible and personal",
      ],
      stats: [
        { value: "100%", label: "Delivered from one source" },
        { value: "7+", label: "Equipment categories" },
        { value: "1:1", label: "Personal support" },
      ],
      badge: "Staff",
    },
    contact: {
      overline: "Contact",
      title: "Let's plan your event",
      text: "Send us your request – whether it's an event, equipment, training or consulting. We'll get back to you as soon as possible.",
      phoneLabel: "Phone consultation on request",
      locationLabel: "Operating throughout Germany",
      form: {
        name: "Name *",
        email: "Email *",
        phone: "Phone",
        subject: "Subject",
        message: "Your message *",
        submit: "Send request",
        sending: "Sending…",
        required: "* Required fields",
      },
      toastSuccess: "Thank you! Your request has been sent.",
      toastError: "An error occurred. Please try again.",
      toastValidation: "Please fill in name, email and message.",
    },
    footer: {
      tagline:
        "Event service, consulting & support for hospitality – full delivery, equipment rental and training.",
      impressum: "Legal notice",
      rights: "All rights reserved.",
    },
    impressum: {
      title: "Legal Notice (Impressum)",
      backHome: "Back to homepage",
      h_anbieter: "Information according to § 5 DDG",
      legalForm: "Legal form: Sole proprietorship",
      h_vertreten: "Represented by",
      h_kontakt: "Contact",
      phone: "Phone",
      email: "Email",
      h_verantwortlich: "Responsible for content according to § 18 (2) MStV",
      h_streit: "Consumer dispute resolution / Universal arbitration board",
      streit:
        "We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.",
      h_haftungInhalte: "Liability for content",
      haftungInhalte:
        "As a service provider, we are responsible for our own content on these pages in accordance with § 7 (1) DDG and general laws. According to §§ 8 to 10 DDG, however, we as a service provider are not obliged to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.",
      h_haftungLinks: "Liability for links",
      haftungLinks:
        "Our website may contain links to external third-party websites over whose content we have no influence. Therefore, we cannot assume any liability for this external content. The respective provider or operator of the linked pages is always responsible for their content.",
      h_urheber: "Copyright",
      urheber:
        "The content and works created by the site operators on these pages are subject to German copyright law. Contributions by third parties are marked as such.",
    },
  },
};
